import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Error404.module.css';
import imageError from '../../assets/images/The-Record-Hub-Logo.png';
const Error404 = () => {
    return (
        <div className={styles.container}>
            <div className={styles.leftContainer}>
                <img src={imageError} alt='Error 404' />
            </div>
            <div className={styles.rightContainer}>
                <h1 className={styles.number}>404</h1>
                <h1>... Oops! Page not Found</h1>
                <Link to={''} className={styles.homeButton}>
                    Home
                </Link>
            </div>
        </div>
    );
};

export default Error404;
